import { useState } from 'react';

import { useStaffJoinBedroomMutation } from '../../../../hooks/useStaffJoinBedroomMutation';
import { useStaffLeaveBedroomMutation } from '../../../../hooks/useStaffLeaveBedroomMutation';

export const useBedroomUsersDrawer = (eventId: string, bedroomId: string) => {
  const [isEventUsersDrawerOpen, setIsEventUsersDrawerOpen] =
    useState<boolean>(false);
  const { staffLeaveBedroom } = useStaffLeaveBedroomMutation();
  const { staffJoinBedroom } = useStaffJoinBedroomMutation();

  const onRemoveUser = (userId: string) => {
    staffLeaveBedroom(bedroomId, eventId, userId);
  };

  const onCloseEventUsersDrawer = () => {
    setIsEventUsersDrawerOpen(false);
  };

  const onAddUserToBedroom = (userId: string) => {
    onCloseEventUsersDrawer();
    staffJoinBedroom(bedroomId, eventId, userId);
  };

  const openEventUsersDrawer = () => {
    setIsEventUsersDrawerOpen(true);
  };

  return {
    onRemoveUser,
    isEventUsersDrawerOpen,
    onCloseEventUsersDrawer,
    onAddUserToBedroom,
    openEventUsersDrawer,
  };
};
